// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ps-layout{min-width:1200px;height:100vh;display:flex;flex-direction:column}.ps-layout a,.ps-layout img{-webkit-user-drag:none}", ""]);
// Exports
module.exports = exports;
